import React from 'react'

const ComplianceAMLPolicy = () => {
    const customStyle = {
        fontWeight: 600,
    };

    const bulletStyle = {
        fontWeight: 500,
        marginLeft: 55,
    };

    return (
        <div>
            <div class="main-contain pt-5 mt-5 mb-5" style={{ textAlign: 'justify' }}>
                <section>
                    <div id="" class="iq-banner-2">
                        <div class="banner-info">
                            <div class="container">
                                <div class="row justify-content-center">
                                    <div class="col-lg-11">
                                        <div class="banner-text iq-font-white wow fadeIn" data-wow-delay="0.1s">
                                            <h2 class="h2 text-primary">Compliance &amp; AML Policy</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="hero-internal-separator mt-5"></div>
                    </div>

                    <section class="iq-product-description overview-block-pt pt-0">
                        <div class="container">
                            <div class="row justify-content-center">
                                <div class="col-lg-11">

                                    {/* ── Regulatory Awareness ── */}
                                    <p class="mt-4 mb-2 fs-22" style={customStyle}>Regulatory Awareness</p>
                                    <p class="fs-18">
                                        CGO Tokens are digital assets linked to the value of physical gold reserves. The issuer recognizes the importance of regulatory compliance in the evolving digital asset ecosystem.
                                    </p>
                                    <p class="fs-18">
                                        The issuer seeks to align its operations with applicable regulatory frameworks, including guidance provided by the Regulatory Authority in respective jurisdiction.
                                    </p>

                                    {/* ── Issuer Entity ── */}
                                    <p class="mt-4 mb-2 fs-22" style={customStyle}>Issuer Entity</p>
                                    <p class="fs-18">CGO Tokens were issued by:</p>
                                    <p class="fs-18" style={bulletStyle}><strong>ComTech FZCO</strong></p>
                                    <p class="fs-18" style={bulletStyle}>Dubai Airport Free Zone</p>
                                    <p class="fs-18" style={bulletStyle}>United Arab Emirates</p>
                                    <p class="fs-18">
                                        The issuer operates within applicable legal frameworks governing technology companies and digital asset services.
                                    </p>

                                    {/* ── Nature of the Token ── */}
                                    <p class="mt-4 mb-2 fs-22" style={customStyle}>Nature of the Token</p>
                                    <p class="fs-18">
                                        CGO Tokens are designed as asset-linked digital tokens representing the value of physical gold stored in secure vault facilities.
                                    </p>
                                    <p class="fs-18">CGO Tokens are not intended to constitute:</p>
                                    <p class="fs-18" style={bulletStyle}>•&nbsp; securities</p>
                                    <p class="fs-18" style={bulletStyle}>•&nbsp; shares</p>
                                    <p class="fs-18" style={bulletStyle}>•&nbsp; derivatives</p>
                                    <p class="fs-18" style={bulletStyle}>•&nbsp; collective investment schemes</p>
                                    <p class="fs-18">unless explicitly stated under applicable regulatory approvals.</p>

                                    {/* ── Compliance Principles ── */}
                                    <p class="mt-4 mb-2 fs-22" style={customStyle}>Compliance Principles</p>
                                    <p class="fs-18">The issuer aims to operate according to the following principles:</p>
                                    <p class="fs-18" style={bulletStyle}>•&nbsp; Transparency</p>
                                    <p class="fs-18" style={bulletStyle}>•&nbsp; Responsible asset backing</p>
                                    <p class="fs-18" style={bulletStyle}>•&nbsp; Operational integrity</p>
                                    <p class="fs-18" style={bulletStyle}>•&nbsp; Risk disclosure</p>
                                    <p class="fs-18" style={bulletStyle}>•&nbsp; User protection</p>

                                    {/* ── Anti-Money Laundering Compliance ── */}
                                    <p class="mt-4 mb-2 fs-22" style={customStyle}>Anti-Money Laundering Compliance</p>
                                    <p class="fs-18">
                                        The issuer supports industry best practices related to anti-money laundering and financial crime prevention.
                                    </p>
                                    <p class="fs-18">Compliance measures may include:</p>
                                    <p class="fs-18" style={bulletStyle}>•&nbsp; identity verification procedures</p>
                                    <p class="fs-18" style={bulletStyle}>•&nbsp; sanctions screening</p>
                                    <p class="fs-18" style={bulletStyle}>•&nbsp; transaction monitoring</p>
                                    <p class="fs-18" style={bulletStyle}>•&nbsp; cooperation with authorized exchanges implementing KYC programs</p>

                                    {/* ── Custody & Asset Safeguards ── */}
                                    <p class="mt-4 mb-2 fs-22" style={customStyle}>Custody &amp; Asset Safeguards</p>
                                    <p class="fs-18">
                                        The physical gold reserves supporting CGO Tokens are stored with professional vault custodians operating secure storage facilities.
                                    </p>
                                    <p class="fs-18">
                                        Digital token custody may involve institutional digital asset custody providers utilizing secure wallet infrastructure.
                                    </p>

                                    {/* ── Technology Infrastructure ── */}
                                    <p class="mt-4 mb-2 fs-22" style={customStyle}>Technology Infrastructure</p>
                                    <p class="fs-18">
                                        CGO Tokens operate using blockchain technology on the XDC Network.
                                    </p>
                                    <p class="fs-18">
                                        Blockchain technology provides transparent transaction records, enabling public verification of token transfers and circulating supply.
                                    </p>
                                    <p class="fs-18">
                                        However, users acknowledge that blockchain technology involves inherent technological risks.
                                    </p>

                                    {/* ── Regulatory Risk ── */}
                                    <p class="mt-4 mb-2 fs-22" style={customStyle}>Regulatory Risk</p>
                                    <p class="fs-18">
                                        Digital asset regulations continue to evolve globally. The regulatory treatment of tokenized assets may change, potentially impacting the issuance, trading, or custody of CGO Tokens.
                                    </p>
                                    <p class="fs-18">
                                        Users are responsible for ensuring compliance with laws applicable in their jurisdiction.
                                    </p>

                                    {/* ── Jurisdictional Limitations ── */}
                                    <p class="mt-4 mb-2 fs-22" style={customStyle}>Jurisdictional Limitations</p>
                                    <p class="fs-18">
                                        CGO Tokens are not offered to individuals or entities located in jurisdictions where digital asset transactions are restricted or prohibited by law.
                                    </p>
                                    <p class="fs-18">
                                        The issuer may restrict access or services in certain jurisdictions in order to comply with regulatory requirements.
                                    </p>

                                    {/* ── Commitment to Responsible Innovation ── */}
                                    <p class="mt-4 mb-2 fs-22" style={customStyle}>Commitment to Responsible Innovation</p>
                                    <p class="fs-18">
                                        The issuer supports the responsible development of tokenized real-world assets and seeks to maintain transparency and accountability in the operation of CGO Tokens.
                                    </p>
                                    <p class="fs-18">
                                        This compliance statement may be updated periodically to reflect evolving regulatory guidance and operational practices.
                                    </p>

                                    {/* ── Disclaimer ── */}
                                    <p class="mt-4 mb-2 fs-22" style={customStyle}>Disclaimer</p>
                                    <p class="fs-18">
                                        This statement is provided for informational purposes only and does not constitute regulatory approval or licensing by any authority.
                                    </p>

                                </div>
                            </div>
                        </div>
                    </section>

                </section>
            </div>
        </div>
    );
};

export default ComplianceAMLPolicy;
